import script from "./UnexpectedEventShowRegisteredFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnexpectedEventShowRegisteredFile.vue?vue&type=script&setup=true&lang=ts"

import "./UnexpectedEventShowRegisteredFile.vue?vue&type=style&index=0&id=0dffdb7e&lang=css"

const __exports__ = script;

export default __exports__